import { Component, OnInit } from '@angular/core';

import  * as rulesDataObj from "./rules_sample.json";

@Component({
  selector: 'app-ui-rules-auto',
  templateUrl: './ui-rules-auto.component.html',
  styleUrls: ['./ui-rules-auto.component.scss']
})
export class UiRulesAutoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  /* Rules */
  rulesData: any = rulesDataObj;
  rulesDataFiltered = rulesDataObj;
  rulesLoading: boolean = false;
  rulesRadio:any = "Failed";

  /* Counts */
  rulesPassedCount:number = this.rulesData.filter(x=>x.decisionVal.toLowerCase()=="pass").length;
  rulesFailedCount:number = this.rulesData.filter(x=>x.decisionVal.toLowerCase()!="pass").length;

  filterRules(type?) {
    if(type) this.rulesRadio = type;
    switch(this.rulesRadio.toLowerCase()) {
      case 'all':
        this.rulesDataFiltered = this.rulesData;
        break;
      case 'passed':
        this.rulesDataFiltered = this.rulesData.filter(x=>x.decisionVal.toLowerCase()=="pass");
        break;
      case 'failed':
        this.rulesDataFiltered = this.rulesData.filter(x=>x.decisionVal.toLowerCase()!="pass");
        break;
    }
    /* Faker */
    this.rulesLoading = true;
    setTimeout(()=>{ this.rulesLoading = false },800);
    console.log("filterRules RUN");
  }

}
